(function () {
  var MOBILE_MQ = '(max-width: 767px)';

  function chevronSvg(direction) {
  var path =
    direction === 'prev'
      ? 'M15 18L9 12L15 6'
      : 'M9 6L15 12L9 18';

  return (
    '<svg xmlns="http://www.w3.org/2000/svg" class="instagram-video-post__chevron" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false">' +
    '<path d="' +
    path +
    '" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" fill="none"/>' +
    '</svg>'
  );
}

  function buildCarouselDom(root) {
    var slides = root.querySelectorAll(':scope > .instagram-video');
    if (slides.length < 2) return;

    root.setAttribute('data-ig-carousel-init', 'true');
    root.classList.add('instagram-video-post--carousel');

    var inner = document.createElement('div');
    inner.className = 'instagram-video-post__inner';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'instagram-video-post__nav instagram-video-post__nav--prev';
    prev.setAttribute('aria-label', 'Previous post');
    prev.innerHTML = chevronSvg('prev');

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'instagram-video-post__nav instagram-video-post__nav--next';
    next.setAttribute('aria-label', 'Next post');
    next.innerHTML = chevronSvg('next');

    var stage = document.createElement('div');
    stage.className = 'instagram-video-post__stage';

    var swiperEl = document.createElement('div');
    swiperEl.className = 'swiper instagram-video-post__swiper';

    var wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    slides.forEach(function (slide) {
      slide.classList.add('swiper-slide');
      wrapper.appendChild(slide);
    });

    swiperEl.appendChild(wrapper);

    stage.appendChild(swiperEl);

    inner.appendChild(prev);
    inner.appendChild(stage);
    inner.appendChild(next);

    while (root.firstChild) {
      root.removeChild(root.firstChild);
    }
    root.appendChild(inner);

    if (window.instgrm && window.instgrm.Embeds && typeof window.instgrm.Embeds.process === 'function') {
      window.instgrm.Embeds.process();
    }

    root._igCarousel = {
      swiperEl: swiperEl,
      prevEl: prev,
      nextEl: next,
    };
  }

  function createOrDestroySwiper(root) {
    if (!root._igCarousel) return;
    var mobile = window.matchMedia(MOBILE_MQ).matches;
    var cfg = root._igCarousel;

    if (mobile) {
      if (cfg.instance) return;
      if (typeof Swiper === 'undefined') return;

      cfg.instance = new Swiper(cfg.swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 420,
        roundLengths: true,
        resistanceRatio: 0.75,
        watchSlidesProgress: true,
        updateOnWindowResize: true,
        navigation: {
          prevEl: cfg.prevEl,
          nextEl: cfg.nextEl,
        },
        watchOverflow: true,
        observer: true,
        observeParents: true,
        on: {
          init: function () {
            this.update();
          },
        },
      });
    } else {
      if (cfg.instance) {
        cfg.instance.destroy(true, true);
        cfg.instance = null;
      }
    }
  }

  function initInstagramCarousel(root) {
    if (root.getAttribute('data-ig-carousel-init') === 'true') return;
    buildCarouselDom(root);
    createOrDestroySwiper(root);
  }

  function run() {
    document.querySelectorAll('.instagram-video-post').forEach(function (root) {
      if (root.getAttribute('data-ig-carousel-init') === 'true') {
        createOrDestroySwiper(root);
      } else {
        initInstagramCarousel(root);
      }
    });
  }

  function onResize() {
    document.querySelectorAll('.instagram-video-post[data-ig-carousel-init="true"]').forEach(createOrDestroySwiper);
  }

  function refreshSwiperLayout() {
    document.querySelectorAll('.instagram-video-post[data-ig-carousel-init="true"]').forEach(function (root) {
      var cfg = root._igCarousel;
      if (cfg && cfg.instance && typeof cfg.instance.update === 'function') {
        cfg.instance.update();
      }
    });
  }

  var resizeTimer;
  window.addEventListener(
    'resize',
    function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        refreshSwiperLayout();
        onResize();
      }, 120);
    },
    { passive: true }
  );
  window.addEventListener(
    'orientationchange',
    function () {
      setTimeout(refreshSwiperLayout, 300);
    },
    { passive: true }
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  setTimeout(run, 400);
  setTimeout(run, 1600);

  var waitSwiperAttempts = 0;
  function waitSwiper() {
    if (typeof Swiper !== 'undefined') {
      run();
      return;
    }
    waitSwiperAttempts += 1;
    if (waitSwiperAttempts < 120) {
      setTimeout(waitSwiper, 50);
    }
  }
  waitSwiper();
})();
document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll(".lazy-video");

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;
        const source = video.querySelector("source");

        if (source.dataset.src) {
          source.src = source.dataset.src;
          video.load();
        }

        video.play();

        observer.unobserve(video);
      }
    });
  }, {
    threshold: 0.5
  });

  videos.forEach(video => {
    observer.observe(video);
  });
});
